import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

function formatCityName(string) {
  if (string) {
    return toCapitalizeFirstLetter(string.toLowerCase())
  } else {
    return ''
  }
}

export { formatCityName }
